import { useGtm } from '@gtm-support/vue-gtm';
import { getMd5Hash } from '@nzyme/crypto';
import { defineService } from '@nzyme/ioc/Service.js';
import { AuthStore } from '../auth/AuthStore.js';
export const TrackingService = defineService({
    name: 'TrackingService',
    deps: {
        authStore: AuthStore,
    },
    setup: ({ authStore }) => {
        return {
            trackEvent,
        };
        async function trackEvent(event) {
            const gtm = useGtm();
            if (!gtm) {
                return;
            }
            gtm.trackEvent({
                ...event,
                ...(await commonEventProps()),
            });
        }
        async function commonEventProps() {
            await authStore.checkAuth();
            const user = authStore.user;
            return {
                // User ID from crm if logged in, if not we return undefined
                user_id: user?.id,
                logged_in: user ? 'yes' : 'no',
                hashed_email: user?.email ? getMd5Hash(user.email) : undefined,
                hashed_phone: user?.phone ? getMd5Hash(user.phone) : undefined,
            };
        }
    },
});
//# sourceMappingURL=TrackingService.js.map